import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import CustomIcon from './CustomIcon';
import { capitalize } from '../../utils/stringUtils';
import { Button, TextButton } from '@netexknowledge/smart-components';
import { ROLE } from '../../const';

let styles = {
  primaryButton: {
    backgroundColor: props => props.colors.btnSuccess,
    '&:hover': {
      backgroundColor: props => props.colors.btnSuccessHover
    }
  },
  cancelButton: {
    backgroundColor: props => props.colors.btnDefault,
    fontFamily: 'LatoSemibold',
    color: '#fff',
    fontSize: '16px',
    padding: '13px',
    border: 'none',
    borderRadius: '3px',
    float: 'right',
    marginRight: '20px',
    '&:hover': {
      backgroundColor: props => props.colors.btnDefaultHover
    }
  }
};

class PanelsBottomRowButton extends React.Component {
  static propTypes = {
    hideRow: PropTypes.any,
    disableButtons: PropTypes.any,
    hidePrimaryButton: PropTypes.bool,
    disableRemakeButton: PropTypes.any,
    showCancelButton: PropTypes.any,
    cancelButtonText: PropTypes.any,
    cancelButtonDanger: PropTypes.bool,
    handlePrimaryButtonClick: PropTypes.func,
    handleSecondaryButtonClick: PropTypes.func,
    secondaryButtonClasses: PropTypes.string,
    classes: PropTypes.object,
    icon: PropTypes.any,
    topContent: PropTypes.any
  };

  renderIcon = () => <CustomIcon name={this.props.icon} size={10} classes="button-icon" />;

  renderCancelButton() {
    const { handleSecondaryButtonClick, disableButtons, cancelButtonText, cancelButtonDanger } = this.props;
    return (
      <Button
        id="cancel"
        className={`secondaryButton responsive-panel-button`}
        label={cancelButtonText ? I18n.t(cancelButtonText) : I18n.t('common.cancel')}
        disabled={disableButtons}
        onClick={handleSecondaryButtonClick}
        btnDanger={cancelButtonDanger}
      />
    );
  }

  renderPrimaryButton() {
    const { handlePrimaryButtonClick, primaryButtonText, disableButtons } = this.props;
    return (
      <Button
        id="primary"
        className={`primaryButton responsive-panel-button`}
        label={capitalize(I18n.t(primaryButtonText))}
        disabled={disableButtons}
        onClick={event => {
          event.preventDefault();
          // repeat task false
          handlePrimaryButtonClick(false);
        }}
      />
    );
  }

  //
  renderRemakeButton() {
    const {
      handleRemakeButtonClick,
      secondaryButtonText,
      disableButtons,
      disableRemakeButton,
      role,
      task
    } = this.props;
    const shouldRenderButton = secondaryButtonText && !disableButtons && !disableRemakeButton && role !== ROLE.STUDENT;

    // check if there is more than one day left until the expiration date
    const now = new Date();
    const dueDate = new Date(task && task.dueDate);
    const differenceInMilliseconds = task && dueDate - now;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return (
      shouldRenderButton &&
      (task.allowExpiredResponse || differenceInDays > 1) && (
        <TextButton
          id="remakeButton"
          style={{ color: 'red' }}
          text={capitalize(I18n.t(secondaryButtonText))}
          onClick={event => {
            event.preventDefault();
            // repeat task true
            handleRemakeButtonClick(true);
          }}
        />
      )
    );
  }

  scrollAssignTaskButton() {
    // scroll when textarea hidden behind of assign task button
    const el = document.getElementById('drawer-container');
    if (el && el.parentElement) {
      const input = document.getElementById('description-input-wrapper');
      if (input) {
        const windowHeight = window.innerHeight;
        let inputRelativeOffset = windowHeight - input.offsetTop;
        setTimeout(() => {
          el.scrollTop = inputRelativeOffset < 0 ? input.offsetTop + 50 : inputRelativeOffset + 170;
        }, 200);
      }
    }
  }

  render() {
    const { task, showCancelButton, hideRow, hidePrimaryButton, topContent } = this.props;

    let activeClass = hideRow ? '' : 'active';
    const topContentClass = topContent ? 'with-top-content' : '';

    const renderButtons = () => (
      <>
        {!hideRow && this.scrollAssignTaskButton()}
        {!hideRow && !hidePrimaryButton && this.renderPrimaryButton()}
        {!hideRow && !hidePrimaryButton && this.renderRemakeButton()}
        {!hideRow && showCancelButton && this.renderCancelButton()}
      </>
    );

    return (
      <div className={`bottom-row-button-container sticky ${activeClass} ${topContentClass}`}>
        <div className="bottom-row-button-wrapper">
          {!hideRow && topContent}
          {topContent ? <div className="bottom-row-button-actions">{renderButtons()}</div> : renderButtons()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    role: state.classrooms.selectedClassroom.classroom.role,
    task: state.task.selectedTask
  };
}

export default connect(mapStateToProps, null)(injectSheet(styles)(PanelsBottomRowButton));
